import { Component, OnInit, OnDestroy, Input, ElementRef } from '@angular/core';
import { ThorChatService, UtilsService, ThorService, ThorWebsocketService } from 'app/helpers/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-thor-widget',
  templateUrl: './thor-widget.component.html',
  styleUrls: ['./thor-widget.component.scss']
})
export class ThorWidgetComponent implements OnInit, OnDestroy {
  isProcessing: boolean = false;
  queryText: string = '';
  isListening: boolean = false;
  private processingSubscription: Subscription;

  @Input() suggestion: string = 'Ask me anything...';
  @Input() defaultQuestions: string[] = [];

  constructor(
    private thorChatService: ThorChatService,
    // private voiceService: ThorVoiceService,
    private adminThorService: ThorService,
    private utils: UtilsService,
    private thorWebsocketService: ThorWebsocketService,
    private eRef: ElementRef
  ) { }

  thinkingText: string = 'Thinking';
  private thinkingInterval: any;

  ngOnInit() {
    this.processingSubscription = this.thorChatService.isProcessing$.subscribe(status => {
      this.isProcessing = status;
      if (status) {
        this.startThinkingAnimation();
      } else {
        this.stopThinkingAnimation();
      }
    });
  }

  private startThinkingAnimation() {
    this.stopThinkingAnimation();
    let dots = 0;
    this.thinkingInterval = setInterval(() => {
      dots = (dots + 1) % 4;
      this.thinkingText = 'Thinking' + '.'.repeat(dots);
    }, 500);
  }

  private stopThinkingAnimation() {
    if (this.thinkingInterval) {
      clearInterval(this.thinkingInterval);
      this.thinkingInterval = null;
    }
    this.thinkingText = 'Thinking';
  }

  async toggleVoice() {
  }

  async cancelVoice() {
  }


  onKeyEnter(event: any) {
    if (event.key === 'Enter') {
      this.submitQuery();
    }
  }

  async submitQuery() {
    if (this.queryText.trim()) {
      // Lazy connection: Connect if not already connected
      if (this.thorWebsocketService.getReadyState() !== 1) { // 1 = OPEN
        // Always generate a fresh session ID on connection
        const sessionId = this.thorChatService.getNewSessionId();
        await this.thorWebsocketService.connect(sessionId, 'PORTFOLIO').catch(err => {
          console.error('Thor Widget: Initial Connection Failed', err);
        });
      }

      this.isProcessing = true;
      this.startThinkingAnimation();
      try {
        // Send query
        const payload = {
          message: this.queryText
        };
        this.thorChatService.setLatestQuery(this.queryText);
        this.thorWebsocketService.send(payload);
        this.queryText = '';
      } catch (err) {
        this.isProcessing = false;
        console.error('Thor Widget: Text Send Error', err);
      }
    }
  }

  selectQuestion(question: string) {
    if (this.isProcessing) return;
    this.queryText = question;
    this.submitQuery();
  }

  /**
 * Helper to ensure LiveKit is connected before any communication
 */
  /*
  private async ensureRoomConnected() {
    const sessionId = this.thorChatService.getNewSessionId();
    const tokenResponse: any = await this.adminThorService.getVoiceToken(sessionId).toPromise();
    await this.voiceService.connectToRoom(tokenResponse.token, tokenResponse.livekit_url);
  }
  */

  ngOnDestroy() {
    if (this.processingSubscription) {
      this.processingSubscription.unsubscribe();
    }

    // Disconnect WebSocket
    this.thorWebsocketService.disconnect();

    // Commented out LiveKit cleanup
    // this.voiceService.disconnectRoom();
    // this.thorChatService.stop();
  }
}